
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcConverter as ObcConverterElement} from '@oicl/openbridge-webcomponents/dist/automation/converter/converter.js';
 
 
 

 
 export const ObcConverter = createComponent({
   react: React,
   tagName: 'obc-converter',
   elementClass: ObcConverterElement,
   events: {
     
   }
  });
 
 